/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, EventEmitter, Output } from '@angular/core';
import { of$ } from '@gh/rx';
import { Observable } from 'rxjs';

export interface WizardStepBeforeNextEvent {
  name: string;

  preventDefault(): void;
}

@Directive({
  selector: '[ghWizardStep][ghWizardStepBeforeNext]',
})
export class WizardStepBeforeNextDirective {
  @Output('ghWizardStepBeforeNext') beforeNext = new EventEmitter<WizardStepBeforeNextEvent>();

  validate(): Observable<boolean> {
    let sucessed = true;

    this.beforeNext.emit({
                           // @ts-ignore
      name,
      preventDefault: () => sucessed = false,
    });

    return of$(sucessed);
  }

}
